export default "__VITE_ASSET__CMTq$ByS__"